import { useLazyQuery, useQuery } from "@apollo/client";
import { WAREHOUSES } from "../warehouse.queries";
import { WarehousesQuery, WarehousesQueryVariables } from "../../../__generated__/WarehousesQuery";

export const useWarehouses = (variables: WarehousesQueryVariables) => {
  return useQuery<WarehousesQuery, WarehousesQueryVariables>(WAREHOUSES, { variables });
};

export const useLazyWarehouses = () => {
  return useLazyQuery<WarehousesQuery, WarehousesQueryVariables>(WAREHOUSES);
};
